import { isBrowser } from '../../utils/environment';

export const UPDATE_PROGRESS = 'UPDATE_PROGRESS';

export function ProgressbarStart() {
    return (dispatch, getState) => {
        if (isBrowser()) {
            dispatch({
                type: UPDATE_PROGRESS,
                payload: { active: true, ending: false },
            });
        }
    };
}

/*
	Action to end the progressbar by first setting it to "ending"
	then after 100 ms dispatching an other action to end it.
*/
export function ProgressbarEnd() {
    return (dispatch, getState) => {
        if (isBrowser()) {
            setTimeout(function () {
                dispatch({
                    type: UPDATE_PROGRESS,
                    payload: { active: false, ending: false },
                });
            }, 100);

            dispatch({
                type: UPDATE_PROGRESS,
                payload: { active: true, ending: true },
            });
        }
    };
}
